import { p, strong, ul, hr, wrapHTML } from './htmlUtils';

/**
 * Format LinkedIn post data as HTML (matches LinkedInRenderer.tsx)
 */
export const formatLinkedInHTML = (data: any): string => {
  if (!data || !data.posts) {
    return wrapHTML(p('No LinkedIn content available'));
  }

  const sections: string[] = [];

  // Header if multiple posts
  if (data.posts.length > 1) {
    sections.push(p(`${strong('LinkedIn Posts:')} ${data.posts.length} posts`));
  }

  const posts = data.posts.map((post: any, index: number) => {
    const sections: string[] = [];

    // Post number if multiple posts
    if (data.posts.length > 1) {
      sections.push(p(`${strong(`Post ${index + 1} of ${data.posts.length}`)}`));
    }

    // Main content
    sections.push(p(post.content.replace(/\n/g, '<br/>')));

    // Hashtags
    if (post.hashtags && post.hashtags.length > 0) {
      const hashtags = post.hashtags.map((tag: string) => `${tag}`).join(' ');
      sections.push(p(hashtags));
    }

    // Call to Action
    if (post.call_to_action) {
      sections.push(p(`${strong('CTA:')} ${post.call_to_action}`));
    }

    // Tone
    if (post.tone) {
      sections.push(p(`${strong('Tone:')} ${post.tone}`));
    }

    // Engagement Hooks
    if (post.engagement_hooks && post.engagement_hooks.length > 0) {
      sections.push(p(strong('Engagement Hooks:')));
      sections.push(ul(post.engagement_hooks));
    }

    return sections.join('');
  });

  return wrapHTML([...sections, posts.join(hr())].join(''));
};
